/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form, Select, DatePicker } from 'antd'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import { 
	CIVIL_STATUS , RESIDENCY_OWNERSHIP, RELATION_IN_HEAD, RELIGION
} from '../../../../constants/lookup'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form } = this.props
		const { getFieldDecorator, getFieldValue } = form
        
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col md={8} sm={24}>
						<Form.Item label='First Name'>
							{ getFieldDecorator('first_name', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter First Name'/>
							)}
						</Form.Item>
					</Col>
					<Col md={8} sm={24}>
						<Form.Item label='Middle Name'>
							{ getFieldDecorator('middle_name', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Middle Name'/>
							)}
						</Form.Item>
					</Col>
					<Col md={8} sm={24}>
						<Form.Item label='Last Name'>
							{ getFieldDecorator('last_name', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Last Name'/>
							)}
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col md={4} sm={24}>
						<Form.Item label='Gender'>
							{ getFieldDecorator('gender', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Gender'>
									<Select.Option value='Male'>Male</Select.Option>
									<Select.Option value='Female'>Female</Select.Option>
									<Select.Option value='Gay'>Gay</Select.Option>
									<Select.Option value='Bisexual'>Bisexual</Select.Option>
									<Select.Option value='Transgender'>Transgender</Select.Option>
									<Select.Option value='Lesbian'>Lesbian</Select.Option>
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Birthday'>
							{ getFieldDecorator('birthday', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<DatePicker style={{ width: '100%' }} format={'ll'} />
							)}
						</Form.Item>
					</Col>
					<Col md={5} sm={24}>
						<Form.Item label='Civil Status'>
							{ getFieldDecorator('civil_status', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Civil Status'>
									{
										CIVIL_STATUS.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={5} sm={24}>
						<Form.Item label='Contact Number'>
							{ getFieldDecorator('contact_no', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Contact number' />
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Citizenship'>
							{ getFieldDecorator('citizenship', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Citizenship' />
							)}
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col md={4} sm={24}>
						<Form.Item label='Birth Place'>
							{ getFieldDecorator('birth_place', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Birth Place' />
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Residency Type'>
							{ getFieldDecorator('residency_ownership', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Residency Type'>
									{
										RESIDENCY_OWNERSHIP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Date of Residency'>
							{ getFieldDecorator('residency_date', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<DatePicker style={{ width: '100%' }} format={'ll'} />
							)}
						</Form.Item>
					</Col>
					<Col md={2} sm={24}>
						<Form.Item label='Nuclear Family'>
							{ getFieldDecorator('nuclear_family', {
								initialValue: 1,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Input type='number' />
							)}
						</Form.Item>
					</Col>
					<Col md={5} sm={24}>
						<Form.Item label='Relation to head of family'>
							{ getFieldDecorator('relation_in_head', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Relation in head'>
									{
										RELATION_IN_HEAD.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={5} sm={24}>
						<Form.Item label='Other relation'>
							{ getFieldDecorator('others_relation_in_head', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter other relation' />
							)}
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col md={5} sm={24}>
						<Form.Item label='Religion'>
							{ getFieldDecorator('religion', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Religion'>
									{
										RELIGION.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={5} sm={24}>
						<Form.Item label='Other religion'>
							{ getFieldDecorator('other_religion', {
								rules: [{
									required: (getFieldValue('religion') && _.isEqual(getFieldValue('religion'), 'Other specify')),
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									disabled={!(getFieldValue('religion') && _.isEqual(getFieldValue('religion'), 'Other specify'))}
									placeholder='Enter other religion'
								/>
							)}
						</Form.Item>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
